module.exports = __webpack_public_path__ + "static/img/10.3ea03d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/10.png
// module id = t1Yx
// module chunks = 0